// ru俄语
export default {
    CustomSelect: {
        '请选择': 'Выберите',
    },
    TopNav: {
        '创作者': 'Создатель',
        '游客': 'Гость',
        '请登录后体验完整功能': 'Войдите для полного функционала',
        '登录': 'Войти',
        '免费试用': 'Бесплатная пробная версия',
        '退出登录': 'Выйти',
        '个人中心': 'Мой аккаунт',
        '我的视频': 'Мои видео',
        '额度管理': 'Управление кредитами',
        '首页': 'Главная',
        'AI创作': 'ИИ-творчество',
        '多参考': 'Мульти-референс',
        '文本视频': 'Текст в видео',
        '图片视频': 'Изображение в видео',
        '文生图': 'Текст в изображение',
        '图生图': 'Изображение в изображение',
        '会员中心': 'подписчик',
        '概览': 'Обзор',
        '我的创作': 'Мои работы',
        '账单管理': 'Управление счетами',
        '生成任务': 'Задачи генерации',
        '价格': 'Цены',
        '新闻资讯': 'Новости',
        '确定要退出登录吗？': 'Вы хотите выйти?',
        '提示': 'Подсказка',
        '确定': 'Подтвердить',
        '取消': 'Отмена',
        '退出成功': 'Вы вышли из системы',
        '视频展示': 'Видео'
    },
    AiLayout: {
        'AI创作中心': 'Центр создания с ИИ',
        '视频生成': 'Генерация видео',
        '图片生成': 'Генерация изображений',
        '我的作品': 'Мои работы',
        '我的创作': 'Мои работы',
        '今日剩余额度': 'Остаток кредитов на сегодня',
        '多参考': 'Мульти-референс',
        '文本视频': 'Текст в видео',
        '图片视频': 'Изображение в видео',
        '文生图': 'Текст в изображение',
        '图生图': 'Изображение в изображение',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Платформа нового поколения для генерации видео с ИИ, превращайте идеи в реальность мгновенно',
        '产品': 'Продукты',
        'AI视频': 'Видео с ИИ',
        '价格方案': 'Тарифные планы',
        '新闻资讯': 'Новости',
        '支持': 'Поддержка',
        '帮助中心': 'Центр помощи',
        'API文档': 'Документация API',
        '常见问题': 'Часто задаваемые вопросы',
        '法律': 'Правовая информация',
        '服务条款': 'Условия обслуживания',
        '隐私政策': 'Политика конфиденциальности',
        '使用协议': 'Лицензионное соглашение',
        '版权所有': 'Все права защищены',
        '客服邮箱': 'Email поддержки',
        '复制邮箱': 'Копировать email',
        '开发中': 'В разработке, ожидайте!',
        '链接已复制到剪贴板': 'Ссылка скопирована в буфер обмена',
    },
    MyLayout: {
        '创作者': 'Создатель',
        '退出登录': 'Выйти',
        '概览': 'Обзор',
        '我的创作': 'Мои работы',
        '会员中心': 'Центр подписки',
        '额度管理': 'Управление кредитами',
        '账单管理': 'Управление счетами',
        '生成任务': 'Задачи генерации',
        '确定要退出登录吗？': 'Вы хотите выйти?',
        '提示': 'Подсказка',
        '确定': 'Подтвердить',
        '取消': 'Отмена',
        '退出成功': 'Вы вышли из системы'
    },
    Image: {
        "文本生成图片": "Текст в изображение",
        "图片生成图片": "Изображение в изображение",
        "用文字描述": "Опишите словами желаемое изображение",
        "上传图片素材": "Загрузите материалы изображений, поддерживается генерация нескольких изображений",
        "图片描述": "Описание изображения",
        "描述您想要的图片": "Подробно опишите содержание изображения, которое хотите получить, поддерживается русский или английский язык...",
        "提示描述越详细效果越好": "Подсказка: Чем подробнее описание, тем лучше результат генерации",
        "图片素材": "Материалы изображений",
        "预览图片": "Предпросмотр",
        "上传图片": "Загрузить изображение",
        "支持格式JPGPNG": "Поддерживаются форматы JPG, PNG",
        "最多": "Максимум",
        "张图片": "изображение(я)",
        "超过大小限制": "Превышает лимит в 10 МБ",
        "不是图片文件": "Недействительный файл изображения",
        "最多上传": "Максимальная загрузка",
        "请先上传图片": "Пожалуйста, сначала загрузите материалы изображений",
        "请选择要生成的图片": "Пожалуйста, выберите изображение для генерации",
        "生成结果": "Результат генерации",
        "重新生成成功": "Повторная генерация выполнена успешно",
        "模型": "Модель ИИ",
        "请选择模型": "Пожалуйста, выберите модель генерации",
        "分辨率": "Разрешение вывода",
        "请选择分辨率": "Пожалуйста, выберите разрешение",
        "图片比例": "Соотношение сторон",
        "补充描述": "Дополнительное описание (необязательно)",
        "补充描述提示": "Необязательно: опишите любые дополнительные эффекты или стили для изображения",
        "开始绘制": "Начать рисование",
        "开始生成": "Начать генерацию",
        "生成中": "Генерация, пожалуйста, подождите...",
        "生成成功": "Успешно",
        "图片生成成功": "Изображение успешно создано!",
        "作品已保存到我的作品": "Работа сохранена в 'Мои работы'",
        "继续创作": "Продолжить создание",
        "查看作品": "Посмотреть работу",
        "请输入图片描述": "Введите описание изображения"
    },
    MyCreation: {
        '我的创作': 'Мои работы',
        '查看和管理您的所有作品': 'Просматривайте и управляйте всеми своими работами',
        '预览': 'Предпросмотр',
        '下载': 'Скачать',
        '编辑': 'Редактировать',
        '分享': 'Поделиться',
        '删除': 'Удалить',
        '暂无作品': 'Нет работ',
        '去创作': 'Создать',
        '确定删除': 'Подтвердить удаление',
        '确定要删除作品': 'Вы хотите удалить работу',
        '吗？': '?',
        '此操作不可恢复': 'Это действие необратимо, пожалуйста, будьте осторожны!',
        '取消': 'Отмена',
        '分享作品': 'Поделиться работой',
        '复制链接': 'Копировать ссылку',
        '全部': 'Все',
        '视频': 'Видео',
        '图片': 'Изображение',
        '正在下载:': 'Скачивание: ',
        '链接已复制到剪贴板': 'Ссылка скопирована в буфер обмена',
        '删除成功': 'Удалено успешно'
    },
    Video: {
        "文本生成视频": "Текст в видео",
        "图片生成视频": "Изображение в видео",
        "智能视频生成": "Умная генерация видео",
        "输入文字描述": "Введите текстовое описание",
        "上传1-9张图片": "Загрузите 1-9 изображений",
        "上传图片视频音频": "Загрузить изображение/видео/аудио",
        "视频描述": "Описание видео",
        "描述您想要的视频场景": "Опишите желаемую видеосцену",
        "提示": "Подсказка",
        "图片素材": "Материалы изображений",
        "最多上传": "Максимальная загрузка",
        "张": "изображение(я)",
        "预览": "Предпросмотр",
        "上传图片": "Загрузить изображение",
        "支持格式": "Форматы JPG, PNG, не более 10 МБ на файл, максимум",
        "AI": "ИИ интеллектуально объединяет и создает плавные переходы",
        "动态描述": "Описание движения",
        "描述您希望图片如何动起来": "Опишите, как вы хотите, чтобы изображение двигалось",
        "个": "элемент(ы)",
        "上传视频": "Загрузить видео",
        "上传音频": "Загрузить аудио",
        "描述您希望视频呈现的效果": "Опишите желаемый эффект видео",
        "模型": "Модель",
        "请选择模型": "Пожалуйста, выберите модель",
        "分辨率": "Разрешение",
        "请选择分辨率": "Пожалуйста, выберите разрешение",
        "宽高比": "Соотношение сторон",
        "视频时长": "Длительность видео",
        "生成音频": "Сгенерировать аудио",
        "开启音效": "Включить звуковые эффекты",
        "静音模式": "Беззвучный режим",
        "音频提示": "Подсказка: Загруженное аудио будет использоваться как фоновая музыка, если аудио не загружено, ИИ автоматически сгенерирует музыку",
        "开始生成": "Начать генерацию",
        "积分": "Кредиты",
        "生成中": "Генерация",
        "生成成功": "Успешно",
        "视频生成成功！": "Видео успешно создано!",
        "作品已保存到": "Работа сохранена в 'Мои работы'",
        "继续创作": "Продолжить создание",
        "查看作品": "Посмотреть работу",
        "视频预览": "Предпросмотр видео",
        "关闭": "Закрыть",
        "下载视频": "Скачать видео",
        "您的浏览器不支持视频播放": "Ваш браузер не поддерживает воспроизведение видео",
        "生成进度": "Прогресс генерации",
        "描述": "Описание",
        "时长": "Длительность",
        "秒": "секунд",
        "视频素材": "Видеоматериалы",
        "音频素材": "Аудиоматериалы",
        "双图融合模式": "Режим слияния двух изображений",
        "开始下载视频": "Начать скачивание видео",
        "请输入视频描述": "Введите описание видео",
        "请至少上传一张图片": "Пожалуйста, загрузите хотя бы одно изображение",
        "请至少上传一张图片或一个视频": "Пожалуйста, загрузите хотя бы одно изображение или одно видео",
        "最多只能上传": "Максимальная загрузка",
        "超过": "Превышает",
        "限制": "лимит",
        "不是图片文件": "Недействительный файл изображения",
        "不是视频文件": "Недействительный файл видео",
        "不是音频文件": "Недействительный файл аудио"
    },
    Forgot: {
        "找回密码": "Восстановить пароль",
        "请输入您的邮箱，我们将发送验证码": "Введите ваш email, мы отправим код подтверждения",
        "密码重置成功，请使用新密码登录": "Пароль успешно сброшен, войдите с новым паролем",
        "密码重置成功": "Пароль успешно сброшен",
        "您的密码已成功重置，请使用新密码登录": "Ваш пароль успешно сброшен, войдите с новым паролем",
        "立即登录": "Войти сейчас",
        "邮箱": "Email",
        "请输入注册邮箱": "Введите зарегистрированный email",
        "发送验证码": "Отправить код",
        "请输入验证码": "Введите код подтверждения",
        "验证码": "Код подтверждения",
        "新密码": "Новый пароль",
        "设置新密码": "Установить новый пароль",
        "确认新密码": "Подтвердить новый пароль",
        "再次输入新密码": "Введите новый пароль еще раз",
        "重置密码": "Сбросить пароль",
        "返回登录": "Вернуться ко входу",
        "验证中": "Проверка",
        "重置中": "Сброс",
        "弱": "Слабый",
        "中": "Средний",
        "强": "Сильный",
        "请输入邮箱地址": "Введите адрес электронной почты",
        "请输入正确的邮箱格式": "Введите корректный формат email",
        "验证码应为6位数字": "Код подтверждения должен состоять из 6 цифр",
        "请输入新密码": "Введите новый пароль",
        "密码至少需要6位": "Пароль должен содержать не менее 6 символов",
        "请再次输入新密码": "Введите новый пароль еще раз",
        "两次输入的密码不一致": "Введенные пароли не совпадают",
        "验证码已发送": "Код подтверждения отправлен"
    },
    Login: {
        "下一代AI视频生成平台": "Платформа нового поколения для генерации видео с ИИ",
        "一键生成": "Генерация в один клик",
        "支持4K超高清输出": "Поддержка вывода 4K Ultra HD",
        "多种风格模板任选": "Выберите из множества стилей",
        "商用授权无忧使用": "Коммерческая лицензия, используйте без ограничений",
        "欢迎回来": "С возвращением",
        "登录您的账号继续创作": "Войдите, чтобы продолжить создание",
        "邮箱": "Email",
        "请输入邮箱地址": "Введите адрес email",
        "密码": "Пароль",
        "请输入您的密码": "Введите ваш пароль",
        "记住我": "Запомнить меня",
        "忘记密码？": "Забыли пароль?",
        "登录": "Войти",
        "登录中": "Вход",
        "还没有账号？": "Нет аккаунта?",
        "立即注册": "Зарегистрироваться",
        "请输入正确的邮箱格式": "Введите корректный формат email",
        "请输入密码": "Введите пароль",
        "密码至少需要6位": "Пароль должен содержать не менее 6 символов",
        "密码不能超过20位": "Пароль не может превышать 20 символов",
        "登录成功": "Вход выполнен успешно"
    },
    Register: {
        "创建账号": "Создать аккаунт",
        "开始您的AI视频创作之旅": "Начните свое путешествие по созданию видео с ИИ",
        "姓名": "Имя",
        "请输入您的姓名": "Введите ваше имя",
        "邮箱": "Email",
        "请输入邮箱地址": "Введите адрес email",
        "获取验证码": "Получить код",
        "验证码": "Код подтверждения",
        "请输入验证码": "Введите код подтверждения",
        "密码": "Пароль",
        "设置密码": "Установить пароль",
        "确认密码": "Подтвердить пароль",
        "再次输入密码": "Введите пароль еще раз",
        "我已阅读并同意": "Я прочитал(а) и соглашаюсь с",
        "服务条款": "Условиями обслуживания",
        "和": "и",
        "隐私政策": "Политикой конфиденциальности",
        "注册中": "Регистрация",
        "已有账号？": "Уже есть аккаунт?",
        "立即登录": "Войти сейчас",
        "弱": "Слабый",
        "中": "Средний",
        "强": "Сильный",
        "请输入姓名": "Введите имя",
        "姓名至少需要2个字符": "Имя должно содержать не менее 2 символов",
        "姓名不能超过20个字符": "Имя не может превышать 20 символов",
        "请输入正确的邮箱格式": "Введите корректный формат email",
        "验证码应为6位数字": "Код подтверждения должен состоять из 6 цифр",
        "请输入密码": "Введите пароль",
        "密码至少需要6位": "Пароль должен содержать не менее 6 символов",
        "密码不能超过20位": "Пароль не может превышать 20 символов",
        "请再次输入密码": "Пожалуйста, подтвердите пароль",
        "两次输入的密码不一致": "Введенные пароли не совпадают",
        "验证码已发送": "Код подтверждения отправлен",
        "注册成功": "Регистрация успешна"
    },
    Faq: {
        '常见问题': 'Часто задаваемые вопросы',
        '您在使用过程中遇到的问题': 'Проблемы, с которыми вы сталкиваетесь при использовании, найдите ответы здесь',
        '搜索您的问题': 'Поиск вопроса...',
        '没有找到相关的问题': 'Похожих вопросов не найдено',
        '查看全部问题': 'Посмотреть все вопросы',
        '没有找到您想要的答案？': 'Не нашли нужный ответ?',
        '我们的客服团队随时为您提供帮助': 'Наша служба поддержки всегда готова помочь вам',
        '复制客服邮箱': 'Копировать email поддержки',
        '链接已复制到剪贴板': 'Ссылка скопирована в буфер обмена'
    },
    Home: {
        '立即订阅': 'Подписаться',
        'AI视频生成新时代': 'Новая эра генерации видео с ИИ',
        '用文字创造': 'Создавайте с помощью слов',
        '无限视频': 'Неограниченное количество видео',
        '让每个人都能成为视频创作者': 'Позвольте каждому стать создателем видео. Просто введите текстовое описание, чтобы получить высококачественное уникальное видео с ИИ.',
        '免费开始': 'Начать бесплатно',
        '观看演示': 'Посмотреть демо',
        'AI生成': 'Создать с ИИ',
        'AI视频': 'Видео с ИИ',
        '三步轻松生成专业视频': 'Три простых шага для создания профессионального видео',
        '输入提示词': 'Введите подсказку',
        '用文字描述您想要的视频内容': 'Опишите словами желаемое содержание видео, чем подробнее, тем лучше',
        '智能生成': 'Умная генерация',
        'AI模型自动理解并创作': 'Модель ИИ автоматически понимает и создает, рендеринг завершается за несколько минут',
        '下载作品': 'Скачать работу',
        '高清视频生成完成': 'Генерация HD видео завершена, готово к скачиванию и использованию',
        'AI视频生成': 'Генерация видео с ИИ',
        '精彩视频': 'Введите текстовое описание, ИИ создаст для вас потрясающее видео',
        '描述您想要的视频场景': 'Опишите желаемую видеосцену, например: Котенок играет под цветущей сакурой, солнечный свет проникает сквозь лепестки...',
        '生成中': 'Генерация...',
        '生成视频': 'Создать видео',
        'AI图片': 'Изображение с ИИ',
        '精美图片': 'Введите текстовое описание, ИИ создаст для вас потрясающее изображение',
        '描述您想要的图片场景': 'Опишите желаемую сцену изображения, например: Горизонт футуристического города, мерцающие неоновые огни, стиль киберпанк...',
        '生成图片': 'Создать изображение',
        '强大功能': 'Мощные функции',
        '让视频创作变得简单有趣': 'Сделайте создание видео простым и увлекательным',
        '案例展示': 'Примеры',
        '来看看用户使用': 'Посмотрите потрясающие работы, созданные',
        '创作的精彩作品': 'пользователями',
        '新闻资讯': 'Новости',
        '了解': 'Узнайте о',
        '的最新动态和产品更新': 'последних новостях и обновлениях продуктов',
        '查看更多': 'Смотреть еще',
        '热门': 'Популярное',
        '最新': 'Последнее',
        '阅读更多': 'Читать далее',
        '选择适合您的方案': 'Выберите подходящий вам план',
        '灵活的定价': 'Гибкие цены для разных потребностей',
        '视频预览': 'Предпросмотр видео',
        '生成成功': 'Успешно',
        '作品已保存到': "Работа сохранена в 'Мои работы'",
        '继续创作': 'Продолжить создание',
        '查看作品': 'Посмотреть работу',
        '请输入视频描述': 'Введите описание видео',
        '视频生成成功！': 'Видео успешно создано!',
        '请输入图片描述': 'Введите описание изображения',
        '图片生成成功！': 'Изображение успешно создано!',
    },
    News: {
        '新闻资讯': 'Новости',
        '了解': 'Узнайте о',
        '的最新动态和产品更新': 'последних новостях и обновлениях продуктов',
        '精选': 'Избранное',
        '阅读': 'Читать',
        '点赞': 'Нравится',
        '热门': 'Популярное',
        '最新': 'Последнее',
        '阅读更多': 'Читать далее',
        '加载中': 'Загрузка...',
        '暂无新闻': 'Нет новостей',
        '清除筛选': 'Очистить фильтр',
        '加载新闻失败': 'Не удалось загрузить новости, повторите попытку позже',
    },
    Price: {
        '选择适合您的方案': 'Выберите подходящий вам план',
        '灵活的定价': 'Гибкие цены для разных потребностей',
        '包月': 'Ежемесячный',
        '包年': 'Годовой',
        '购买积分': 'Купить кредиты',
        '只需要几个视频': 'Нужно всего несколько видео? Без подписки, купите пакет кредитов',
        '产品大全': 'Каталог продуктов',
        '了解': 'Узнайте о',
        '全系列产品的详细信息和支付方式': 'подробной информации и способах оплаты всей линейки продуктов'
    },
    Billing: {
        '账单管理': 'Управление счетами',
        '账户余额': 'Баланс счета',
        '本月支出': 'Расходы за месяц',
        '订单数量': 'Количество заказов',
        '账单列表': 'Список счетов',
        '请选择类型': 'Выберите тип',
        '请选择时间范围': 'Выберите период',
        '订单号': 'Номер заказа',
        '类型': 'Тип',
        '金额': 'Сумма',
        '状态': 'Статус',
        '时间': 'Время',
        '操作': 'Действие',
        '查看详情': 'Подробнее',
        '下载发票': 'Скачать счет',
        '暂无作品': 'Нет работ',
        '去创作': 'Создать',
        '支付方式': 'Способ оплаты',
        '添加支付方式': 'Добавить способ',
        '默认': 'По умолчанию',
        '设为默认': 'Установить по умолчанию',
        '编辑': 'Редактировать',
        '删除': 'Удалить',
        '账单详情': 'Детали счета',
        '交易流水号': 'Номер транзакции',
        '关闭': 'Закрыть',
        '账号': 'Номер счета/карты',
        '请输入账号或卡号': 'Введите номер счета или карты',
        '姓名': 'Имя',
        '请输入持卡人姓名': 'Введите имя владельца карты',
        '有效期': 'Срок действия',
        '请输入CVV码': 'Введите CVV-код',
        '取消': 'Отмена',
        '确认添加': 'Подтвердить добавление',
        '确认修改': 'Подтвердить изменение',
        '确认删除': 'Подтвердить удаление',
        '编辑支付方式': 'Редактировать способ оплаты',
        '确定要删除支付方式': 'Вы хотите удалить этот способ оплаты?',
        '删除后不可恢复': 'Удаление необратимо, пожалуйста, будьте осторожны!',
        '请输入账号': 'Введите номер счета/карты',
        '添加成功': 'Добавлено успешно',
        '修改成功': 'Изменено успешно',
        '已设为默认支付方式': 'Установлен как способ оплаты по умолчанию',
        '删除成功': 'Удалено успешно',
    },
    Credit: {
        '额度管理': 'Управление кредитами',
        '当前可用额度': 'Доступно кредитов',
        '升级会员': 'Улучшить подписку',
        '本月已用': 'Использовано за месяц',
        '视频生成': 'Генерация видео',
        'AI图片': 'Изображение с ИИ',
        '其他': 'Другое',
        '购买额度包': 'Купить пакет кредитов',
        '最受欢迎': 'Самый популярный',
        '额度': 'Кредиты',
        '立即购买': 'Купить сейчас',
        '使用记录': 'История использования',
        '操作': 'Действие',
        '类型': 'Тип',
        '额度变动': 'Изменение кредитов',
        '时间': 'Время',
        '购买': 'Купить',
        '确认购买': 'Подтвердить покупку',
        '金额': 'Сумма: ',
        '获得': 'Получить',
        '取消': 'Отмена',
        '今天': 'Сегодня',
        '昨天': 'Вчера',
    },
    Dashboard: {
        '欢迎回来': 'С возвращением,',
        '创建新视频': 'Создать новое видео',
        '本月生成次数': 'Количество генераций за месяц',
        '剩余额度': 'Остаток кредитов',
        '总视频数': 'Всего видео',
        '会员状态': 'Статус подписки',
        '最近生成': 'Последние генерации',
        '查看全部': 'Смотреть все',
        '视频预览': 'Предпросмотр видео',
        '视频生成中': 'Видео генерируется, подождите для предпросмотра',
    },
    Membership: {
        '会员中心': 'Центр подписки',
        '当前方案': 'Текущий план',
        'Pro 会员': 'Pro подписка',
        '专业创作者首选': 'Лучший выбор для профессиональных создателей',
        '月': 'месяц',
        '会员有效期': 'Срок действия подписки',
        '剩余天数': 'Осталось дней',
        '续费会员': 'Продлить подписку',
        '取消订阅': 'Отменить подписку',
        '本月使用情况': 'Использование за месяц',
        '视频生成': 'Генерация видео',
        '次': 'раз(а)',
        '额度使用': 'Использование кредитов',
        '快速生成': 'Быстрая генерация',
        '升级方案': 'Улучшить план',
        '联系销售': 'Связаться с отделом продаж',
        '会员权益': 'Преимущества подписки',
        '续费后将延长会员有效期30天': 'Продление продлит подписку на 30 дней',
        '取消': 'Отмена',
        '确认续费': 'Подтвердить продление',
        '取消后您将失去所有会员权益': 'После отмены вы потеряете все преимущества подписки, остаток кредитов сохранится',
        '再想想': 'Подумать еще раз',
        '确认取消': 'Подтвердить отмену',
        '姓名': 'Имя',
        '请输入您的姓名': 'Введите ваше имя',
        '请输入姓名': 'Введите имя',
        '公司': 'Компания',
        '请输入公司名称': 'Введите название компании',
        '邮箱': 'Email',
        '请输入邮箱地址': 'Введите адрес email',
        '请输入邮箱': 'Введите email',
        '请输入正确的邮箱格式': 'Введите корректный формат email',
        '需求': 'Потребность',
        '请描述您的需求': 'Опишите вашу потребность',
        '提交': 'Отправить',
        '请填写需求': 'Пожалуйста, опишите потребность',
        '续费成功': 'Продление успешно! Срок подписки продлен',
        '已取消订阅': 'Подписка отменена, она истечет в конце срока',
        '提交成功': 'Отправлено успешно, мы свяжемся с вами в ближайшее время!',
    },
    Task: {
        '生成任务': 'Задачи генерации',
        '新建任务': 'Новая задача',
        '进行中': 'Выполняется',
        '已完成': 'Завершена',
        '失败': 'Не удалась',
        '队列中': 'В очереди',
        '活跃任务': 'Активные задачи',
        '刷新': 'Обновить',
        '暂无活跃任务': 'Нет активных задач',
        '预计剩余': 'Осталось примерно',
        '暂停': 'Пауза',
        '继续': 'Продолжить',
        '取消': 'Отмена',
        '最近完成': 'Недавно завершенные',
        '查看全部': 'Смотреть все',
        '暂无完成的任务': 'Нет завершенных задач',
        '播放': 'Воспроизвести',
        '下载': 'Скачать',
        '分享': 'Поделиться',
        '确认取消': 'Подтвердить отмену',
        '确定要取消任务吗': 'Вы действительно хотите отменить задачу?',
        '已消耗的额度将无法退还': 'Потраченные кредиты не подлежат возврату',
        '返回': 'Назад',
        '分享作品': 'Поделиться работой',
        '复制链接': 'Копировать ссылку',
        '任务列表已刷新': 'Список задач обновлен',
        '已暂停': 'На паузе',
        '生成中': 'Генерация',
        '已恢复': 'Возобновлена',
        '任务已取消': 'Задача отменена',
        '链接已复制到剪贴板': 'Ссылка скопирована в буфер обмена',
    },
    VideoShow: {
        '示例': 'Примеры',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Тщательно подобранная коллекция клипов из нашей демонстрационной библиотеки. Нажмите на любую карточку, чтобы начать создание контента в похожем стиле.',
        '全部': 'Все',
        '电影感': 'Кинематографичный',
        '角色': 'Персонажи',
        '产品': 'Продукты',
        '自然': 'Природа',
        '趣味': 'Забавный',
        '加载中': 'Загрузка',
        '暂无展示': 'Нет доступных демо',
        '视频预览': 'Предпросмотр видео',
    },
    Request: {
        '加载中': 'Загрузка...',
        '您已退出登录': 'Вы вышли из системы, вы можете войти снова',
        '确认退出': 'Подтвердить выход',
        '重新登录': 'Войти снова',
        '错误': 'Ошибка',
        '网络错误': 'Ошибка сети',
        '下载中': 'Скачивание...'
    },
    Other: {
        '剩余额度': 'Остаток средств',
        '去登录': 'Войти',
        '请登录后查看': 'Пожалуйста, войдите, чтобы просмотреть',
        '任务': 'Задача',
        '可在「生成任务」中查看详情': ', подробности можно посмотреть в «Задачах генерации»',
        '查看详情': 'Подробнее',
        '排队中': 'В очереди',
        '运行中': 'Выполняется',
        '取消': 'Отмена',
        '成功': 'Успешно',
        '失败': 'Ошибка',
        '超时': 'Тайм-аут',
        '最后更新': 'Последнее обновление:',
        '视频生成': 'Генерация видео',
        '活跃用户': 'Активные пользователи',
        '用户评分': 'Оценка пользователей',
        '万': 'тысяч',
        '快速生成': 'Быстрая генерация',
        '先进的AI模型': 'Передовые модели ИИ, создающие высококачественное видео за несколько минут',
        '多种风格': 'Различные стили',
        '多种风格任您选择': 'Реалистичный, аниме, художественный и многие другие стили на ваш выбор',
        '高清输出': 'Вывод HD',
        '支持4K超高清视频输出': 'Поддержка вывода видео в сверхвысоком разрешении 4K, детали видны четко',
        '商用授权': 'Коммерческая лицензия',
        '生成的视频可用于商业用途': 'Сгенерированные видео можно использовать в коммерческих целях, без опасений по поводу авторских прав',
        '原价': 'Исходная цена',
        '积分价格说明': 'Пояснение к ценам на кредиты',
        '系列': 'Серия',
        '模型': 'Модель',
        '分辨率': 'Разрешение',
        '积分': 'Кредиты',
        '秒': 'секунда',
        '秒示例': 'секунд (пример)',
        '图片模型': 'Модель изображений',
        '图片为': 'Изображение',
        '系列产品': 'Продукты серии, в настоящее время поддерживается',
        '支持使用任意机型查看完整体验': ', поддерживается использование любых устройств для полного ознакомления.',
        '计费方式': 'Способ оплаты',
        '张': 'изображение(я)',
        '按生成张数计费': 'Оплата за количество сгенерированных изображений',
        '普通用户': 'Обычный пользователь',
        '无记录': 'Нет записей',
        '总支出': 'Общий расход',
        '月总使用': 'Общее использование за месяц',
        '月视频使用': 'Использование видео за месяц',
        '月图片使用': 'Использование изображений за месяц',
        '生成成功': 'Генерация успешна',
        '视频总生成': 'Всего сгенерировано видео',
        '图片总生成': 'Всего сгенерировано изображений',
        '生成中': 'Генерация, пожалуйста, подождите 1-3 минуты',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Коллекция тщательно отобранных клипов из нашей демонстрационной библиотеки.',
        '最近7天': 'Последние 7 дней',
        '最近30天': 'Последние 30 дней',
        '本月': 'Этот месяц',
        '上月': 'Прошлый месяц',
    }
}